// @ts-ignore
/* eslint-disable */

// 地区管理接口
export * from './regions';
